import {makeApiCall} from '../core';
import type {
  CreateServiceAreaRequest,
  ItemEnvelope,
  ListEnvelope,
  ServiceArea,
  UpdateServiceAreaRequest,
} from '@ruta/shared';

// =====================
// Service Area Management API
// =====================
//
// These wrappers unwrap the standard response envelopes so callers receive
// the resource directly and never read an envelope key themselves.

export const getServiceAreas = async (): Promise<ServiceArea[]> => {
  const res = await makeApiCall<ListEnvelope<ServiceArea>>('GET', '/service-areas');
  return res.data;
};

export const createServiceArea = async (
  serviceArea: CreateServiceAreaRequest,
): Promise<ServiceArea> => {
  // makeApiCall already uses makeApiCallWithRefresh internally via dynamic import
  // This ensures token has org claims before creating service area
  const res = await makeApiCall<ItemEnvelope<ServiceArea>>('POST', '/service-areas', serviceArea);
  return res.data;
};

export const updateServiceArea = async (
  serviceAreaId: string,
  serviceArea: UpdateServiceAreaRequest,
): Promise<ServiceArea> => {
  const res = await makeApiCall<ItemEnvelope<ServiceArea>>(
    'PUT',
    `/service-areas/${serviceAreaId}`,
    serviceArea,
  );
  return res.data;
};

export const deleteServiceArea = async (
  serviceAreaId: string,
): Promise<{ id: string }> => {
  const res = await makeApiCall<ItemEnvelope<{ id: string }>>(
    'DELETE',
    `/service-areas/${serviceAreaId}`,
  );
  return res.data;
};
